import { render, staticRenderFns } from "./ActivixButton.vue?vue&type=template&id=aa509e14&"
import script from "./ActivixButton.vue?vue&type=script&lang=js&"
export * from "./ActivixButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports